import React from "react";
import { AiFillGithub, AiOutlineTwitter, AiOutlineDownload } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { BsArrowUpRight } from "react-icons/bs";
import pdf from "../../Assets/dharmikresume.pdf";
import { socials } from "../../data/content";

const CONTACT_LINKS = [
  { ...socials.github, Icon: AiFillGithub },
  { ...socials.twitter, Icon: AiOutlineTwitter },
  { ...socials.linkedin, Icon: FaLinkedinIn },
];

function Contact() {
  return (
    <section className="section" id="contact">
      <div className="container">
        <div className="contact">
          <div className="contact__grid">
            <div>
              <p className="eyebrow">Contact</p>
              <h2>Find me on</h2>
              <div className="btn-row contact__actions">
                <a
                  href={pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn--primary"
                >
                  <AiOutlineDownload /> Download CV
                </a>
              </div>
            </div>

            <ul className="socials">
              {CONTACT_LINKS.map(({ name, handle, url, Icon }) => (
                <li key={name}>
                  <a
                    href={url}
                    className="social"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon aria-hidden="true" />
                    <span className="social__meta">
                      <span className="social__name">{name}</span>
                      <span className="social__handle">{handle}</span>
                    </span>
                    <BsArrowUpRight className="social__arrow" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
